import Es6Promise from 'es6-promise'
Es6Promise.polyfill()

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App'
import router from './router'
import VueCookie from 'vue-cookie'
// import VueHead from 'vue-head'
import Meta from 'vue-meta'
// import MultiLanguage from 'vue-multilanguage'
import Vuex from 'vuex'
import VueAnalytics from 'vue-analytics'

var VueScrollTo = require('vue-scrollto');

// import WebpPlugun from 'vue-webp-plugin';
// Vue.use(WebpPlugun);

Vue.use(Vuetify)
Vue.use(VueCookie)
// Vue.use(VueHead)
Vue.use(Meta)
// Vue.use(MultiLanguage, {
//   	en: {
// 		language: 'Language',
// 		more: 'more',
//   	},
//   	de: {
// 		language: 'Sprache',
// 		more: 'mehr'
//   	}
// });
Vue.use(Vuex);
Vue.use(VueAnalytics, {
	id: 'UA-108901537-1'
});
Vue.use(VueScrollTo, {
	container: "#frame",
	// container: "body",
	duration: 500,
	easing: "ease",
	offset: -32,
	force: true,
	cancelable: true,
	onStart: false,
	onDone: false,
	onCancel: false,
	x: true,
	y: true
});
const store = new Vuex.Store({
	state: {
		language: 'en',
		count: 1
	},
	mutations: {
		increment: state => state.count++,
		decrement: state => state.count--
	}
})
Vue.config.productionTip = false

/* eslint-disable no-new */
var app = new Vue({
	el: '#app',
	router,
	computed: {
		language () {
			return store.state.language
		}
	},
	template: '<App/>',
	components: { App }
})

document.addEventListener('DOMContentLoaded', function () {
 	app.$mount('#app')
})



// WEBPACK FOOTER //
// ./src/main.js